import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { MARKET } from '../../constants/market';
import {
  RADIUS_SLIDER_STEPS_MAP,
  RADIUS_SLIDER_DEFAULT_STEP_INDEX,
} from '../../constants/radiusValues';
import getRadiusParse from '../../utils/parseRadius';
import Slider from '../Slider';
import {
  selectDealersList,
  setRadius,
  setToggleRadiusLoading,
} from '../../reducers/dealersListReducer';

const MapRadiusSlider: React.FC = () => {
  const { t, i18n } = useTranslation();
  const lang = i18n.languages?.[0] || 'en';
  const dispatch = useDispatch();
  // const lang = i18n.languages?.[0] || 'en';
  const { radius, centerLocation, radiusIsLoading } = useSelector(selectDealersList);

  const radiusLabelGetter = (stepIndex: number) =>
    `${getRadiusParse(RADIUS_SLIDER_STEPS_MAP[stepIndex], lang)} ${
      MARKET === 'CAN' ? 'km' : 'miles'
    }`;

  // useCallback(() => {
  //   // Call onChange with the default value
  //   // the value we send out is always in km
  //   setRadius(RADIUS_SLIDER_STEPS_MAP[RADIUS_SLIDER_DEFAULT_STEP_INDEX]);
  // }, [setRadius]);

  return (
    <Slider
      value={RADIUS_SLIDER_STEPS_MAP.findIndex((step) => step === radius)}
      onChange={(stepIndex) => {
        // call the onChange callback we got:
        // the value we send out is always in km
        dispatch(setToggleRadiusLoading(true));
        dispatch(setRadius(RADIUS_SLIDER_STEPS_MAP[stepIndex]));
      }}
      valueLabelGetter={radiusLabelGetter}
      title={t('dealerLocationSearch.slider.radius')}
      min={0}
      max={RADIUS_SLIDER_STEPS_MAP.length - 1}
      stepSize={1}
      dots
      disabled={!centerLocation || radiusIsLoading}
    />
  );
};

export default MapRadiusSlider;
